<div
  #phoneFrame
  class="phone-frame"
  [class.phone-frame--responsive]="isPhoneResponsive"
>
  <rn-generic-phone #genericPhone [size]="phoneSize">
    <product-group-preview-react
      [messageId]="'productGroup-focusAiPreview'"
      [logoUrl]="productGroup.branding.icon_s3_url || ''"
      [color]="productGroup.branding.color || '#231F20'"
      [showProductGroup]="!productGroup?.hide_pg_wire_display_name"
      [productGroupName]="productGroup?.name || ''"
      [bannerUrl]="productGroup?.branding?.banner_s3_url || ''"
      [productGroupDescription]="productGroup?.description || ''"
      [showBanner]="productGroup?.show_banner"
      [showLogo]="productGroup?.show_logo"
      [showTitleBar]="productGroup?.show_title_bar"
      [hideHamburger]="productGroup?.hide_hamburger"
    ></product-group-preview-react>

    <!-- Non loading state:
    1. If message is null and no error, show instruction text.
    2. If message is not null and no error, show wire-preview-react component.
    3. If failure, show error message. -->
    @if (!focusAiService.isGenerating()) {
      <!-- 1 -->
      @if (!message && !errorMessage) {
        <div class="instruction-text">
         {{ instructionText || 'Upload files and click "Generate" to see a summarized message based on your content.'}}
        </div>
      }
      <!-- 2 -->
      @if (message && !errorMessage) {
        <wire-preview-react
          [message]="message"
          [components]="[message]"
          [productGroup]="productGroup"
          [brandingColor]="productGroup.branding.color || '#231F20'"
          [language]="language"
          >
        </wire-preview-react>
      }
      <!-- 3 -->
      @if (errorMessage) {
        <div class="error-container">
          <div class="error-icon">
            <i class="fa-regular fa-square-exclamation fa-5x"></i>
          </div>
          <div><strong>Message unable to generate.</strong></div>
          <p>{{ errorMessage }}</p>
        </div>
      }
    }

    <!-- Loading spinner during API request to generate message -->
    @if (focusAiService.isGenerating()) {
      <div class="loading-container">
        <app-spinner
          [styleRules]="{ width: '150px', height: '150px' }"
        ></app-spinner>
        <div><strong>Message is generating.</strong></div>
        <span>This may take up to 20 seconds.</span>
      </div>
    }
  </rn-generic-phone>
</div>
@if (message && !errorMessage && !focusAiService.isGenerating()) {
  <div
    class="feed-back"
    >
    <div>Help us improve - is this result useful?</div>
    <button
      class="positive"
      [class.selected]="feedback === 'positive'"
      (click)="sendFeedBack('positive')"
      >
      <i class="fa-regular fa-thumbs-up fa-lg"></i>
    </button>
    <button
      class="negative"
      [class.selected]="feedback === 'negative'"
      (click)="sendFeedBack('negative')"
      >
      <i class="fa-regular fa-thumbs-down fa-lg"></i>
    </button>
  </div>
}
